import { render, staticRenderFns } from "./ExportColumnPicker.vue?vue&type=template&id=8040dea4&scoped=true&"
import script from "./ExportColumnPicker.vue?vue&type=script&lang=js&"
export * from "./ExportColumnPicker.vue?vue&type=script&lang=js&"
import style0 from "./ExportColumnPicker.vue?vue&type=style&index=0&id=8040dea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8040dea4",
  null
  
)

export default component.exports